import { Phone } from "lucide-react";
import Reveal from "@/components/Reveal";
import { BtnPrimary } from "@/components/Btn";
import { COMPANY } from "@/config/company";

export default function CTABand() {
  return (
    <section data-testid="cta-band" className="relative border-t border-white/10 bg-steel px-5 py-20 md:px-10 md:py-28 lg:px-16">
      <span
        aria-hidden
        className="pointer-events-none absolute right-0 top-0 select-none font-display text-[22vw] font-bold uppercase leading-none text-white/[0.025] md:text-[16vw]"
      >
        MMC
      </span>
      <div className="mx-auto grid max-w-7xl gap-10 lg:grid-cols-12 lg:items-end">
        <Reveal className="lg:col-span-8">
          <p className="font-tech text-[10px] uppercase tracking-[0.3em] text-molten">Richiedi un preventivo</p>
          <h2 className="mt-5 font-display text-4xl font-semibold uppercase leading-[1.02] tracking-tight sm:text-5xl lg:text-6xl">
            Hai un progetto in acciaio?
            <br />
            <span className="text-stroke">Parliamone in officina.</span>
          </h2>
          <p className="mt-6 max-w-xl leading-relaxed text-fog">
            {COMPANY.intro}
          </p>
        </Reveal>
        <Reveal delay={0.15} className="lg:col-span-4 lg:justify-self-end">
          <div className="flex flex-col items-start gap-5">
            <BtnPrimary to="/contatti" testid="cta-band-preventivo-btn">
              Richiedi un preventivo
            </BtnPrimary>
            <a
              href={COMPANY.phoneHref || "#"}
              data-testid="cta-band-phone"
              className="inline-flex items-center gap-3 font-tech text-xs tracking-[0.15em] text-white/50 transition-colors duration-300 hover:text-molten"
            >
              <Phone className="size-4 text-molten" /> {COMPANY.phoneDisplay}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
